import { pxToRem } from '@fluentsms/agentnet-web-components';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const orderInsightStyles = makeStyles((theme: Theme) =>
  createStyles({
    brdBtm: {
      borderBottom: '1px solid #E9E9E9',
      padding: theme.spacing(1, 0),
      pageBreakInside: 'avoid',
      '& *': {
        fontSize: pxToRem(12),
      },
    },
    alignCenter: {
      alignItems: 'center',
    },
    labelCol: {
      minWidth: '25%',
      maxWidth: '25%',
      marginRight: theme.spacing(3),
    },
    flexGrow: {
      flex: '1',
    },
    ml1: {
      margin: theme.spacing(0, 0, 0, 0),
    },
    mb1: {
      marginBottom: theme.spacing(1),
    },
    minWidth: {
      marginRight: theme.spacing(1),
      minWidth: '100px',
      display: 'inline-block',
      fontWeight: 500,
    },
    fontSizeNormal: {
      fontSize: pxToRem(12),
    },
    bold: {
      fontWeight: 800,
      textTransform: 'uppercase',
    },
    displayFlex: {
      display: 'flex',
    },
    removeFirstAlertMargin: {
      '& > :first-of-type': {
        marginTop: 0,
      },
    },
  }),
);

export default orderInsightStyles;
